import React from 'react';

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen pt-[160px]">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#041230] to-[#032744] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-6">
            Contact Us
          </h1>
          <p className="text-xl text-center max-w-3xl mx-auto">
            Ready to find your dream home? Get in touch with our expert team today.
          </p>
        </div>
      </div>

      {/* Contact Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            {/* Contact Information */}
            <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
              <h2 className="text-2xl font-bold text-gray-900 mb-8 border-b pb-4 border-gray-200 text-center">Get in Touch</h2>
              <div className="space-y-8">
                <div className="flex items-center transition-all hover:translate-x-1 duration-200">
                  <div className="w-12 h-12 bg-gradient-to-r from-[#041230] to-[#032744] rounded-lg flex items-center justify-center mr-4 shadow-md flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Office Address</h3>
                    <p className="text-gray-600">Marungai Rd, Mariammankovil Post<br />Thanjavur 613501, TamilNadu, India</p>
                  </div>
                </div>
                
                <div className="flex items-center transition-all hover:translate-x-1 duration-200">
                  <div className="w-12 h-12 bg-gradient-to-r from-[#041230] to-[#032744] rounded-lg flex items-center justify-center mr-4 shadow-md flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Phone Number</h3>
                    <p className="text-gray-600">+91 7358 43 2777 | +91 7358 63 2777 | +91 7358 09 2777</p>
                  </div>
                </div>
                
                <div className="flex items-center transition-all hover:translate-x-1 duration-200">
                  <div className="w-12 h-12 bg-gradient-to-r from-[#041230] to-[#032744] rounded-lg flex items-center justify-center mr-4 shadow-md flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Email Address</h3>
                    <p className="text-gray-600">sales@cholarealtors.com</p>
                  </div>
                </div>
                
                <div className="flex items-center transition-all hover:translate-x-1 duration-200">
                  <div className="w-12 h-12 bg-gradient-to-r from-[#041230] to-[#032744] rounded-lg flex items-center justify-center mr-4 shadow-md flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Office Hours</h3>
                    <p className="text-gray-600">
                      Monday - Friday: 9:00 AM - 6:00 PM<br />
                      Saturday: 10:00 AM - 4:00 PM<br />
                      Sunday: By appointment
                    </p>
                  </div>
                </div>
              </div>

              {/* Map placeholder with improved styling */}
              <div className="mt-10 overflow-hidden rounded-xl shadow-md">
                <div className="bg-gray-100 rounded-lg h-64 flex items-center justify-center relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-300 opacity-50"></div>
                  <div className="relative z-10 text-center px-4">
                    <svg className="w-12 h-12 text-gray-400 mx-auto mb-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    <p className="text-gray-500 font-medium">Interactive Map Coming Soon</p>
                    <p className="text-gray-400 text-sm mt-1">Our office location will be displayed here</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;